export default __webpack_public_path__ + "static/ArtClark-b03efe2ca5f57cb6d320fb07f7e62cb7.jpg";